import { render } from "./FormTextArea.vue?vue&type=template&id=7916c6d7&bindings={\"modelValue\":\"props\",\"required\":\"props\",\"label\":\"props\",\"config\":\"props\",\"readOnly\":\"props\",\"uuid\":\"props\",\"validation\":\"props\",\"validations\":\"props\",\"labelHtml\":\"options\",\"update\":\"options\"}"
import script from "./FormTextArea.vue?vue&type=script&lang=js"
export * from "./FormTextArea.vue?vue&type=script&lang=js"
script.render = render

export default script